import { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "./auth.css";
import MasjidHubLogo from './MasjidHubLogo.png'
import forgetImg from "./resetPassImg.jpg";
import { useTranslation } from "react-i18next";
import {
  useReSendOtpMutation,
  useVerifyAccountMutation,
} from "../../store/Reducer/auth";
import toast from "react-hot-toast";
import { setUser } from "../../store/slices/user";
import { useDispatch } from "react-redux";

const Verify = () => {
  const navigate = useNavigate();
  const [verify, { isLoading }] = useVerifyAccountMutation();
  const [reSendOtp, { isLoading: otploading }] = useReSendOtpMutation();
const dispatch = useDispatch();
  const { t } = useTranslation();
  const location = useLocation();
  const email = location.state?.email;
  const otpNumber = location.state?.otp;
  const [formData, setFormData] = useState({
    email: email,
    otp: "",
  });

  const [isOtpExpired, setIsOtpExpired] = useState(false);
  const [timer, setTimer] = useState(60); 

  useEffect(() => {
    if (timer > 0) {
      const interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);

      return () => clearInterval(interval); 
    } else {
      setIsOtpExpired(true);
    }
  }, [timer]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await verify(formData);
console.log('response',response?.data)
          dispatch(setUser(response?.data?.data));
          if (response?.data?.data?.data?.permission === 1) {
            navigate("/admin-dashboard");
          }
          else if (response?.data?.data?.data?.permission === 2) {
            navigate("/user-dashboard");
          }
   
    } catch (error) {
      toast.error(error?.data?.message || "An error occurred");
    }
  };

  const handleResendOtp = async (e) => {
    // Logic to resend OTP goes here
    setTimer(60); // Reset the timer to 1 minute
    setIsOtpExpired(false); // Reset the resend button visibility

    e.preventDefault();

    try {
      const response = await reSendOtp(email);
      if (response.error) {
        toast.error(response?.error?.data?.message);
      }
      toast.success("OTP has been resent.");
    } catch (error) {
      console.log("Login Error:", error);
    }
  };

  return (
    <>
      <div className="bg-[#f5f5f5]">
        <div className="flex justify-center h-screen">
          <div
            className="hidden bg-cover lg:block lg:w-2/3"
            style={{
              backgroundImage: `url(${forgetImg})`,
            }}
          >
            <div className="flex items-center h-full px-20 bg-gray-900 bg-opacity-30">
              <div>
                <h2 className="font-GilroyBold text-2xl font-bold text-white sm:text-4xl">
                  Verify Email
                </h2>
                <p className="max-w-xl mt-3 text-gray-100">
                  {t("forgetPassDescription")}
                </p>
              </div>
            </div>
          </div>
          <div className="flex items-center w-full max-w-md px-6 mx-auto lg:w-2/6">
            <div className="flex-1">
              <div className="text-center">
                <div className="flex justify-center mx-auto">
                  <img
                    alt=""
                    className="w-auto h-7 sm:h-9"
                    src={MasjidHubLogo}
                  />
                </div>
              </div>
              <div className="mt-8">
                <form
                  onSubmit={handleSubmit}
                  className="space-y-4 md:space-y-6"
                >
                <p>We have emailed you a one-time-password (OTP) to verify your email {email}, please enter below to continue.</p>
                <p>{otpNumber}</p>
                  <div>
                    <label
                      className="block mb-2 text-sm text-gray-600"
                      htmlFor="otp"
                    >
                      Otp Number
                    </label>
                    <input
                      className="block w-full px-4 py-2 mt-2 text-gray-700 placeholder-gray-400 bg-white border border-gray-200 rounded-lg focus:border-blue-400 focus:ring-blue-400 focus:outline-none focus:ring focus:ring-opacity-40 [-moz-appearance:_textfield] [&::-webkit-inner-spin-button]:m-0 [&::-webkit-inner-spin-button]:appearance-none [&::-webkit-outer-spin-button]:m-0 [&::-webkit-outer-spin-button]:appearance-none"
                      type="number"
                      id="otp"
                      name="otp"
                      placeholder="Enter OTP Number"
                      value={formData.otp}
                      onChange={(e) =>
                        setFormData({ ...formData, otp: e.target.value })
                      }
                      required
                    />
                  </div>

                  <div className="mt-6">
                    <button
                      type="submit"
                      className="w-full px-4 py-2 tracking-wide text-white transition-colors duration-300 transform bg-[#E0A068] rounded-lg hover:bg-[#d19663]"
                    >
                    
                      {isLoading ? (
                        <div className="flex justify-center items-center gap-2">
                          <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                          </svg>
                          {t("Submit")}
                        </div>
                      ) : (
                        t("Submit")
                      )}
                    </button>
                  </div>
                </form>

                {/* Show remaining time until OTP expires */}
                {!isOtpExpired && (
                  <div className="mt-4 text-center text-gray-600">
                    <p>
                      {t("otpExpiresIn")} {timer} {t("seconds")}
                    </p>
                  </div>
                )}

                {/* Resend OTP Button */}
                {isOtpExpired && (
                  <div className="mt-4 text-center">
                    <button
                      onClick={handleResendOtp}
                      className="text-[#d1925b] focus:outline-none focus:underline hover:underline"
                    >
                      Resend OTP
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Verify;
